<template>
  <div class="animated fadeIn">
    <div v-if="$route.name == 'VideoList'" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify" /> Video
            <router-link
              v-if="$_allowCreating"
              :to="'/admin/content/media_video/new'"
              class="pull-right btn btn-success btn-sm"
              exact
            >
              New
            </router-link>
            <button
              v-if="allowSearchAdministration"
              class="add-to-index-all btn btn-primary btn-sm pull-right"
              @click="$_addToIndexAll('media_video')"
            >
              Add all to search index
              <span class="btn-loader" style="display: none;" />
            </button>
            <button
              v-if="allowRegenerateThumbs"
              class="regenerate-thumbs btn btn-primary btn-sm pull-right"
              @click="$_regenerateThumbs('media_video', 'Video')"
            >
              Regenerate thumbnails
              <span class="btn-loader" style="display: none;" />
            </button>
          </div>

          <div class="card-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Search by video title"
            >
          </div>

          <EmptyBtns
            :empty-search="emptySearch"
            @showEmpty="() => emptySearch = true"
            @showAll="() => emptySearch = false"
          />

          <BulkBtns
            :class="{ hidden: !choosenEntities.length }"
            entity-type="media_video"
            unpublish-empty-endpoint="media/video/unpublish-empty"
            :choosen-entities="choosenEntities"
            :show-index-btn="true"
            @changePublishedBtns="$_changePublishedBtns"
            @clearChoosenEntities="() => choosenEntities = []"
          />

          <div class="card-block spinner-parent">
            <spinner ref="spinner" size="md" text="Loading ..." />

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>

            <div class="table-responsive">
              <table v-if="total" class="entities table table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th class="table-list__cell--narrow">
                      <input ref="allEntities" type="checkbox" @change="$_selectAllEntities">
                    </th>
                    <th>ID</th>
                    <th>Thumbnail</th>
                    <th>Title</th>
                    <th>Actions</th>
                    <th>Included in Picks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in entities" :key="item.id" :data-id="item.id">
                    <td class="table-list__cell--narrow text-center">
                      <input v-model="choosenEntities" type="checkbox" :value="item.id">
                    </td>
                    <td>{{ item.id }}</td>
                    <td class="table-list__cell--narrow text-center">
                      <img :src="validateUrl(item.thumbnail)" alt="" style="max-height: 100px;">
                    </td>
                    <td>{{ item.title }}</td>
                    <td class="table-list__cell--narrow table-list__videos">
                      <div>
                      <button
                        v-if="allowSearchAdministration"
                        class="add-to-index-single btn btn-primary btn-sm"
                        @click="$_addToIndexSingle('media_video', item.id)"
                      >
                        Add to index
                        <span class="btn-loader" style="display: none;" />
                      </button>
                      <router-link
                        v-if="$_allowUpdating(item)"
                        class="btn btn-primary btn-sm"
                        :to="{ name: 'VideoEdit', params: { id: item.id }}"
                      >
                        Edit
                      </router-link>
                      <button
                        v-if="allowPublishing"
                        class="btn btn-primary btn-sm"
                        @click="$_changePublished(item.published, 'media_video', item.id)"
                      >
                        <template v-if="item.published">Unpublish</template>
                        <template v-else>Publish</template>
                        <span :ref="`publishBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                      <button
                        class="btn btn-primary btn-sm"
                        @click="$_regThumb(item, 'media_video', 'Video')"
                      >
                        Reg. thumb
                        <span :ref="`_regThumbBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                      <button
                        v-if="$_allowDeleting(item)"
                        class="btn btn-danger btn-sm"
                        @click="$_deleteEntity(item, 'media/video/', 'Video')"
                      >
                        Delete
                        <span :ref="`deleteBtnLoader_${item.id}`" class="btn-loader" style="display: none;" />
                      </button>
                      <open-on-site
                        :source-route="item.route"
                      />
                      </div>
                      <div>
                      <v-select :options="videoSeries" v-model="selectedVideoSeries[item.id]" @change="selectVideoSeries(item.id, selectedVideoSeries[item.id])" label="title" class="btn btn-success v-select-video" placeholder="Add to series">
                        <template slot="option" slot-scope="option">
                          <span>{{ option.title }}</span>
                        </template>
                      </v-select>
                      </div>
                      <div>
                        <span :ref="`videoSeriesBtnLoader_${item.id}`"  class="btn-loader" style="display: none; margin-top: 5px;" />
                      </div>

                    </td>
                    <td class="table-list__cell--narrow text-center">
                      <input v-if="item.included_in_picks" type="checkbox" :value="item.id" @change="$_sendPicks($event, item.id, 'media_video')" class="add-to-picks" checked>
                      <input v-else type="checkbox" :value="item.id" @change="$_sendPicks($event, item.id, 'media_video')" class="add-to-picks">
                      <span :ref="`pickBtnLoader_${item.id}`"  class="btn-loader" style="display: none;" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-if="total === 0">
              There are no entities for your request
            </div>

    

            <nav>
              <pager
                :total="total"
                :offset="offset"
                :size="perPage"
                @page-changed="$_changePage"
              />
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Pager from '@/global/components/Pager';
import BulkBtns from '@/global/components/BulkBtns';
import EmptyBtns from '@/global/components/EmptyBtns';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
// Mixins
import ListPageMixin from '@/mixins/ListPageMixin';
import CommonPageMixin from '@/mixins/CommonPageMixin';

export default {
  name: 'VideoList',

  components: {
    pager: Pager,
    BulkBtns,
    EmptyBtns,
    'open-on-site': OpenOnSiteButton,
  },

  mixins: [ListPageMixin, CommonPageMixin],

  data() {
    return {
      videoSeries: [],
      selectedVideoSeries: [],
      selectStatus: '',
    }
  },

  mounted() {
    this.getVideoSeries()
  },

  methods: {
    validateUrl(url) {
      if (url.indexOf('://') !== -1) {
        return url;
      }
      return this.$config.app_api.host + url;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      const searchString = encodeURI(this.searchQuery);
      const page = this.perPage ? (this.offset / this.perPage + 1) : 1;
      const searchProcessId = Math.random();
      this.searchProcessId = searchProcessId;
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/video${this.emptySearch ? '/show-empty' : ''}`, {
        params: {
          search_string: searchString,
          page,
        },
      }).then((response) => {
        if (this.searchProcessId === searchProcessId) {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.total = response.data.meta.pagination.total;
          this.perPage = response.data.meta.pagination.per_page;

          const videoArr = _.cloneDeep(response.data);
          delete videoArr.meta;
          this.entities = Object.keys(videoArr).map(e => videoArr[e]);
        }
      }).catch((error) => { this.$_errorCallback(error); });
    },

    getVideoSeries() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/video-series?nonpaginated=true`)
      .then((response) => {
        this.videoSeries = response.data;
      })
      .catch((error) => {
        console.error('Error in loading video series', error)
      })
    },

    selectVideoSeries(video_id, video_series) {
      const $btnLoader = $(this.$refs[`videoSeriesBtnLoader_${video_id}`]);
      $btnLoader.show();
      const postFormData = new FormData();
      postFormData.append('ids[]', video_id);
      this.$apiHttp.post(`${this.$config.app_api.prefix}media/video-series/${video_series.id}/attach-videos`, postFormData)
      .then(() => {
        $btnLoader.hide();
      })
      .catch((error) => {
        $btnLoader.hide();
        console.error('Error in creating request', error);
      });
    }
  },
};
</script>


// WEBPACK FOOTER //
// Index.vue?03ffa197